'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _onlinepbxWarning = require('../onlinepbx-warning');

var _onlinepbxWarning2 = _interopRequireDefault(_onlinepbxWarning);

var _onlinepbxModalDots = require('../onlinepbx-modal-dots');

var _onlinepbxModalDots2 = _interopRequireDefault(_onlinepbxModalDots);

var _playerMini = require('../onlinepbx-player/player-mini');

var _playerMini2 = _interopRequireDefault(_playerMini);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// @ts-ignore
var UploadIcon = function () {
  function UploadIcon(props) {
    return _react2['default'].createElement(
      'svg',
      props,
      _react2['default'].createElement('path', {
        d: 'M17.5 12.5v3.333a1.666 1.666 0 0 1-1.667 1.667H4.167A1.667 1.667 0 0 1 2.5 15.833V12.5M14.167 6.667L10 2.5 5.833 6.667M10 2.5v10',
        stroke: '#A8A4B9',
        strokeLinecap: 'round',
        strokeLinejoin: 'round'
      })
    );
  }

  return UploadIcon;
}();

UploadIcon.defaultProps = {
  width: '20',
  height: '20',
  viewBox: '0 0 20 20',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
};
// @ts-ignore

var PlayIcon = function () {
  function PlayIcon(props) {
    return _react2['default'].createElement(
      'svg',
      props,
      _react2['default'].createElement('path', {
        d: 'M5.417 2.5L17.083 10 5.417 17.5v-15z',
        stroke: '#A8A4B9',
        strokeLinecap: 'round',
        strokeLinejoin: 'round'
      })
    );
  }

  return PlayIcon;
}();

PlayIcon.defaultProps = {
  width: '20',
  height: '20',
  viewBox: '0 0 20 20',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
};


var MAX_SIZE = 1024 * 1024 * 8;

var OnlinepbxUploadFile = function (_React$Component) {
  _inherits(OnlinepbxUploadFile, _React$Component);

  function OnlinepbxUploadFile(props) {
    _classCallCheck(this, OnlinepbxUploadFile);

    var _this = _possibleConstructorReturn(this, (OnlinepbxUploadFile.__proto__ || Object.getPrototypeOf(OnlinepbxUploadFile)).call(this, props));

    _this.state = {
      error: '',
      url: '',
      playStatus: 'STOPPED'
    };
    _this.handleReset = _this.handleReset.bind(_this);
    _this.setPlayStatus = _this.setPlayStatus.bind(_this);
    return _this;
  }

  _createClass(OnlinepbxUploadFile, [{
    key: 'handleReset',
    value: function () {
      function handleReset() {
        this.file.value = '';
        this.setState({
          error: '',
          url: '',
          playStatus: 'STOPPED'
        });
        typeof this.props.onReset === 'function' && this.props.onReset();
      }

      return handleReset;
    }()
  }, {
    key: 'setPlayStatus',
    value: function () {
      function setPlayStatus(status) {
        this.setState({ playStatus: status });
      }

      return setPlayStatus;
    }()
  }, {
    key: 'componentDidUpdate',
    value: function () {
      function componentDidUpdate(prevProps) {
        if (prevProps.customId !== this.props.customId) {
          this.setState({
            error: ''
          });
          this.setPlayStatus('STOPPED');
        }
      }

      return componentDidUpdate;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _this2 = this;

        var playStatus = this.state.playStatus;
        var _props = this.props,
            _props$isShowResetBtn = _props.isShowResetBtn,
            isShowResetBtn = _props$isShowResetBtn === undefined ? true : _props$isShowResetBtn,
            placeholder = _props.placeholder,
            _props$fileTypes = _props.fileTypes,
            fileTypes = _props$fileTypes === undefined ? ['audio/wave', 'audio/x-wav', 'audio/x-pn-wav', 'audio/wav', 'audio/mp3', 'audio/mpeg'] : _props$fileTypes,
            _props$accept = _props.accept,
            accept = _props$accept === undefined ? 'audio/wav, audio/mp3' : _props$accept,
            _props$maxSize = _props.maxSize,
            maxSize = _props$maxSize === undefined ? MAX_SIZE : _props$maxSize,
            _props$uploadTitle = _props.uploadTitle,
            uploadTitle = _props$uploadTitle === undefined ? 'Загрузить (Формат wav, mp3. Макс. размер 8 Мб)' : _props$uploadTitle,
            descriptionFilename = _props.descriptionFilename,
            _props$isUpload = _props.isUpload,
            isUpload = _props$isUpload === undefined ? true : _props$isUpload,
            _props$warningUploadF = _props.warningUploadFormat,
            warningUploadFormat = _props$warningUploadF === undefined ? 'Система поддерживает только форматы wav и mp3. Загрузите файл с одним из этих форматов.' : _props$warningUploadF,
            _props$warningUploadS = _props.warningUploadSize,
            warningUploadSize = _props$warningUploadS === undefined ? 'Вы выбрали слишком большой файл. Загрузите файл меньше 8МБ.' : _props$warningUploadS,
            children = _props.children;

        var url = this.state.url || this.props.url;
        var filename = this.props.filename;

        if (playStatus !== 'STOPPED') {
          var defaultColor = this.props.style || { border: '1px solid #0D71D7' };
          return _react2['default'].createElement(
            'div',
            {
              style: defaultColor,
              className: 'onlinepbx__lib__table__upload__player' },
            _react2['default'].createElement(
              'div',
              { title: filename || 'Стандартное', className: 'onlinepbx__lib__table__upload__name' },
              filename || 'Стандартное'
            ),
            _react2['default'].createElement(_playerMini2['default'], {
              isDownload: this.props.isDownload,
              setPlayStatus: function () {
                function setPlayStatus(status) {
                  typeof _this2.props.setPlayStatus === 'function' && _this2.props.setPlayStatus(status);
                  _this2.setPlayStatus(status);
                }

                return setPlayStatus;
              }(),
              onClose: function () {
                function onClose() {
                  return _this2.setPlayStatus('STOPPED');
                }

                return onClose;
              }(),
              playStatus: this.state.playStatus,
              onDownload: this.props.onClickDownload,
              url: url
            })
          );
        }
        var id = this.props.customId || 'upload__file';
        return _react2['default'].createElement(
          'div',
          { className: 'onlinepbx__lib__table__upload__wrapper' },
          _react2['default'].createElement(
            'div',
            { className: 'onlinepbx__lib__table__upload' },
            _react2['default'].createElement('input', {
              ref: function () {
                function ref(node) {
                  if (node && !_this2.file) {
                    _this2.forceUpdate();
                  }
                  _this2.file = node || _this2.file;
                }

                return ref;
              }(),
              onChange: function () {
                function onChange(evt) {
                  var file = evt.target.files[0];
                  var link = URL.createObjectURL(new Blob([file]));
                  if (!file) return;

                  var extension = (file.name || '').split('.').slice(-1)[0];
                  if (!fileTypes.includes(file.type || extension || '')) {
                    _this2.setState({ error: 'format' });
                    return;
                  }

                  if (file.size > maxSize) {
                    _this2.setState({ error: 'size' });
                    return;
                  }
                  _this2.setState({ error: '', url: link });
                  typeof _this2.props.onChange === 'function' && _this2.props.onChange(file);
                }

                return onChange;
              }(),
              className: 'onlinepbx__lib__upload__input',
              id: id,
              type: 'file',
              accept: accept
            }),
            _react2['default'].createElement(
              'div',
              { className: 'onlinepbx__lib__table__upload__content' },
              children || _react2['default'].createElement(
                'div',
                { className: 'onlinepbx__lib__table__upload__content__left' },
                (filename || !placeholder) && _react2['default'].createElement(
                  'div',
                  { title: filename || 'Стандартное', className: 'onlinepbx__lib__table__upload__name' },
                  filename || 'Стандартное'
                ),
                !filename && placeholder && _react2['default'].createElement(
                  'div',
                  { title: placeholder, className: 'onlinepbx__lib__table__upload__placeholder' },
                  placeholder
                ),
                filename && descriptionFilename && _react2['default'].createElement(
                  'div',
                  { title: descriptionFilename, className: 'onlinepbx__lib__table__upload__name__description' },
                  descriptionFilename
                )
              ),
              (!!this.props.audiofile || !!isUpload || !!this.props.isDownload || !!isShowResetBtn) && _react2['default'].createElement(
                'div',
                { className: 'onlinepbx__lib__table__upload__controls' },
                this.props.audiofile && _react2['default'].createElement(
                  'button',
                  {
                    title: '\u0412\u043E\u0441\u043F\u0440\u043E\u0438\u0437\u0432\u0435\u0441\u0442\u0438',
                    onClick: function () {
                      function onClick() {
                        typeof _this2.props.onClickPlay === 'function' && _this2.props.onClickPlay();
                        _this2.setPlayStatus('PLAYING');
                      }

                      return onClick;
                    }(), className: 'onlinepbx__lib__table__upload__button' },
                  _react2['default'].createElement(PlayIcon, null)
                ),
                !!isUpload && _react2['default'].createElement(
                  'label',
                  {
                    title: uploadTitle,
                    className: 'onlinepbx__lib__table__upload__button', htmlFor: id },
                  _react2['default'].createElement(UploadIcon, { className: 'onlinepbx__lib__table__upload__button__icon' })
                ),
                (!!this.props.isDownload || !!isShowResetBtn) && _react2['default'].createElement(
                  'div',
                  { className: 'onlinepbx__lib__table__upload__button' },
                  _react2['default'].createElement(_onlinepbxModalDots2['default'], {
                    buttons: [].concat(_toConsumableArray(this.props.isDownload ? [{
                      buttonName: 'Скачать',
                      onClick: function () {
                        function onClick() {
                          return typeof _this2.props.onClickDownload === 'function' && _this2.props.onClickDownload();
                        }

                        return onClick;
                      }()
                    }] : []), _toConsumableArray(isShowResetBtn ? [{ buttonName: 'Сбросить', onClick: this.handleReset }] : []))
                  })
                )
              )
            )
          ),
          (this.props.warningText || this.state.error) && _react2['default'].createElement(
            'div',
            { className: 'onlinepbx__lib__table__upload__warning' },
            _react2['default'].createElement(_onlinepbxWarning2['default'], {
              text: this.state.error === 'size' && warningUploadSize || this.state.error === 'format' && warningUploadFormat || this.props.warningText
            })
          ) || ''
        );
      }

      return render;
    }()
  }]);

  return OnlinepbxUploadFile;
}(_react2['default'].Component);

exports['default'] = OnlinepbxUploadFile;